<template>
  <section class="content-wrap">
    <ProductContent :title="producTitle" :content="productContent" id="Product"/>
    <ProductKindContent/>
    <AppDownContent/>
    <div class="techBox">
      <TechKind/>
    </div>
    <AboutUs id="aboutUs"/>
    <AppActive id="appActive"/>
  </section>
</template>

<script>
import ProductContent from "@/components/ProductContent"
import ProductKindContent from "@/components/ProductKindContent"
import AppDownContent from "@/components/AppDownContent"
import TechKind from "@/components/TechKind"
import AboutUs from '@/components/AboutUs'
import AppActive from '@/components/AppActive'
export default {
  components: {
    ProductContent,
    ProductKindContent,
    AppDownContent,
    TechKind,
    AboutUs,
    AppActive
  },
  data(){
    return{
      producTitle:'鲁商通产品',
      productContent:'鲁商通依托于鲁商生态，为您提供多元的数字科技产品',
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrap {
  position: relative;
  // z-index: 2;
  background-color: #fff;
}
@media (max-width: 767.98px) {

 .techBox{
    background: #F2F2F2;
    // padding-top: 40px;
 }
}
</style>